import { EvidencesTypeValueEnum } from '../../../../../../utils/enums/evidences'
import { Grid, Box, Typography, IconButton, Pagination, Icon } from '@mui/material'
import { useStyles } from './styles'
import { EvidencesCard } from '../../typing'
import CustomAccordion from '../../../../../../components/accordion'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { Fragment, useState } from 'react'
import { FullscreenExit } from '@mui/icons-material'
import { FileModal } from '../fileModal'
import { ModelThree } from '../details'
import { useTranslation } from 'react-i18next'
import { icons } from '../../../../../../utils/icons'
const EvidenceCard = ({ evidences, newStyle, type, handleChangePage, pagination = 0, expanded, onToggle, }: EvidencesCard) => {
  const styles = useStyles()
  const { t } = useTranslation()
  const [modal, setModal] = useState({
    open: false,
    src: ''
  })

  function displayMedia({ src }: { src: string }) {
    setModal(prev => ({ ...prev, open: true, src }))
  }
  function closeModal() {
    setModal(prev => ({ ...prev, open: false }))
  }

  const components = {

    [EvidencesTypeValueEnum.VIDEO]: newStyle ? (
      <CustomAccordion
        title={(
          <Box sx={styles.title}>
            <Box className='count'><Typography>{evidences?.length}</Typography></Box>

            <Typography variant='subtitle'>{t('reportFolio.detail.general.video')}</Typography>
          </Box>
        )}
        description={
          <Fragment>
            <Grid container spacing={1}>
              {
                evidences.map(video => (
                  <Grid item xs={4} key={video?.src}>
                    {
                      <CustomPaper elevation={2} sx={styles.videos}>
                        <video >
                          <source src={video?.src} type="video/mp4" />
                        </video>

                        <IconButton onClick={() => { displayMedia({ src: video?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
                      </CustomPaper>
                    }
                  </Grid>
                ))
              }
            </Grid>

            <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.VIDEO} />
          </Fragment>
        }
        expanded={expanded} // Estado de expansión individual
        onChange={onToggle} // Función para alternar expansión
        accordionProps={{ sx: styles.container }}
      />
    ) : (
      <Grid item xl={6} lg={6} md={6} sm={6}>
        <Box>
          <Box sx={styles.videos}>
            <video controls key={evidences?.[pagination]?.src}>
              <source src={evidences?.[pagination]?.src} type="video/mp4" />
            </video>
          </Box>

          <Box sx={styles.stepsIndicatorContainer}>
            <Pagination
              size="small"
              siblingCount={0}
              count={evidences?.length}
              page={pagination + 1}
              onChange={(_: unknown, page: number) => {
                if (handleChangePage) {
                  handleChangePage({ page, type: 'video' })
                }
              }}
            // showFirstButton
            // showLastButton
            />
          </Box>
        </Box>
      </Grid>
    ),
    [EvidencesTypeValueEnum.IMAGE]: newStyle ? (
      <CustomAccordion
        title={(
          <Box sx={styles.title}>
            <Box className='count'><Typography>{evidences?.length}</Typography></Box>

            <Typography variant='subtitle'>{t('reportFolio.detail.general.images')}</Typography>
          </Box>
        )}
        description={(
          <>
            <Grid container spacing={1}>
              {
                evidences.map(image => (
                  <Grid item xs={4} key={image?.src}>
                    {
                      <CustomPaper elevation={2} sx={styles.images}>
                        <img src={image?.src} alt="" />
                        <IconButton onClick={() => { displayMedia({ src: image?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
                      </CustomPaper>
                    }
                  </Grid>
                ))
              }
            </Grid>

            <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.IMAGE} />
          </>
        )}
        expanded={expanded} // Estado de expansión individual
        onChange={onToggle} // Función para alternar expansión
        accordionProps={{ sx: styles.container }}
      />
    ) : (
      <Grid item xl={6} lg={6} md={6} sm={6}>
        <Box>
          <Box sx={styles.images}>
            <img src={evidences[pagination]?.src} alt="" />
          </Box>

          <Box sx={styles.stepsIndicatorContainer}>
            <Pagination
              size="small"
              siblingCount={0}
              count={evidences?.length}
              page={pagination + 1}
              onChange={(_: unknown, page: number) => {
                if (handleChangePage) {
                  handleChangePage({ page, type: 'image' })
                }
              }}
            // showFirstButton
            // showLastButton
            />
          </Box>
        </Box>
      </Grid>
    ),
    [EvidencesTypeValueEnum.SIGN]: newStyle ? (
      <CustomAccordion
        title={(
          <Box sx={styles.title}>
            <Box className='count'><Typography>{evidences?.length}</Typography></Box>

            <Typography variant='subtitle'>{t('reportFolio.detail.general.sign')}</Typography>
          </Box>
        )}
        description={(
          <>
            <Grid container spacing={1}>
              {
                evidences.map(image => (
                  <Grid item xs={4} key={image?.src}>
                    {
                      <CustomPaper elevation={2} sx={styles.images}>
                        <img src={image?.src} alt="" />
                        <IconButton onClick={() => { displayMedia({ src: image?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
                      </CustomPaper>
                    }
                  </Grid>
                ))
              }
            </Grid>

            <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.IMAGE} />
          </>
        )}
        expanded={expanded} // Estado de expansión individual
        onChange={onToggle} // Función para alternar expansión
        accordionProps={{ sx: styles.container }}
      />
    ) : (
      <Grid item xl={6} lg={6} md={6} sm={6}>
        <Box>
          <Box sx={styles.images}>
            <img src={evidences[pagination]?.src} alt="" />
          </Box>

          <Box sx={styles.stepsIndicatorContainer}>
            <Pagination
              size="small"
              siblingCount={0}
              count={evidences?.length}
              page={pagination + 1}
              onChange={(_: unknown, page: number) => {
                if (handleChangePage) {
                  handleChangePage({ page, type: 'image' })
                }
              }}
            // showFirstButton
            // showLastButton
            />
          </Box>
        </Box>
      </Grid>
    ),
    [EvidencesTypeValueEnum.COMMENT]: (
      <CustomAccordion
        title={(
          <Box sx={styles.title}>
            <Box className='count'><Typography>{evidences?.length}</Typography></Box>

            <Typography variant='subtitle'>{t('reportFolio.detail.general.comments')}</Typography>
          </Box>
        )}
        description={(
          <Box sx={styles.comments}>
            {evidences?.map((itemComments, index) => (
              <Fragment key={index}>
                <ModelThree title={itemComments.name ?? ''} description={''} date={''} />
              </Fragment>
            ))}
          </Box>
        )}
        expanded={expanded} // Estado de expansión individual
        onChange={onToggle} // Función para alternar expansión
        accordionProps={{ sx: styles.container }}
      />
    ),
    [EvidencesTypeValueEnum.DOCUMENT]: (
      <CustomAccordion
        title={(
          <Box sx={styles.title}>
            <Box className='count'><Typography>{evidences?.length}</Typography></Box>

            <Typography variant='subtitle'>{t('reportFolio.detail.general.documents')}</Typography>
          </Box>
        )}
        description={(
          <Box sx={styles.documentsContainer}>
            {evidences?.map((itemDocuments, index) => (
              <Box
                key={index}
                sx={styles.documentItems}
                onClick={() => {
                  window.open(itemDocuments?.src, 'blank')
                }}
              >
                <Typography variant="subtitle" sx={styles.documentName}>{itemDocuments?.name}</Typography>

                <Icon>{icons('visibility')}</Icon>
              </Box>
            ))}
          </Box>
        )}
        expanded={expanded} // Estado de expansión individual
        onChange={onToggle} // Función para alternar expansión
        accordionProps={{ sx: styles.container }}
      />
    ),
  }

  return components[type] ?? <p>{t('reportFolio.detail.general.noFound')}</p>
}

export { EvidenceCard }
